class creditCardValidate {

    // validateCardNumber(inputNum) {
    //     var digit, digits, flag, sum, _i, _len;
    //     flag = true;
    //     sum = 0;
    //     digits = (inputNum + '').split('').reverse();
    //     for (_i = 0, _len = digits.length; _i < _len; _i++) {
    //         digit = digits[_i];
    //         digit = parseInt(digit, 10);
    //         if ((flag = !flag)) {
    //         digit *= 2;
    //         }
    //         if (digit > 9) {
    //         digit -= 9;
    //         }
    //         sum += digit;
    //     }
    //     return sum % 10 === 0;
    // };

    validate(cardNumber, cardHolder, expMonth, expYear, securityCode, ) {
        

        // if(this.validateCardNumber(cardNumber)){
        //     return {status: false, message: 'Número do cartão inválido.'};
        // }
        
        if (!cardNumber) {
            return {status: false, message: 'Informe o número do cartão.', error: 'cardNumber' };
        }
        
        if(cardNumber.length < 16){
            return {status: false, message: 'Numéro do cartão inválido.', error: 'cardNumber' };
        }

        if ((expMonth > 12 || expMonth < 0) || !expMonth ) {
            return {status: false, message: 'Informe uma data de validade correta.',  error: 'cardDate'};
        }

        if (securityCode.length < 3 || !securityCode) {
            return {status: false, message: 'Informe o código de segurança.',  error: 'cardCVV'};
        }

        if (cardHolder.length < 1 || !cardHolder) {
            return {status: false, message: 'Informe o nome do titular do cartão.',  error: 'cardName'};
        }

        return {status: true};
    }

}

export default new creditCardValidate();